import { FC } from 'react'
import { Chip, ChipProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Close } from 'svgIcons'

type CustomChipProps = ChipProps

const CustomChip: FC<CustomChipProps> = ({
  color,
  classes: classesOfProps,
  deleteIcon,
  className,
  ...props
}) => {
  const classes = useStyles()

  return (
    <Chip
      className={clsx(classes.root, className, {
        [classes.primaryColorRoot]: color === 'primary',
      })}
      classes={{
        deleteIcon: clsx(
          {
            [classes.primaryColorDeleteIcon]: color === 'primary',
          },
          classesOfProps?.deleteIcon,
        ),
        ...classesOfProps,
      }}
      deleteIcon={deleteIcon || <Close />}
      {...props}
    />
  )
}

export default CustomChip

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: '#fdfdfd',
      border: '1px solid #dddddd',
    },
    primaryColorRoot: {
      backgroundColor: '#f0fcff',
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
    primaryColorDeleteIcon: {
      color: theme.palette.primary.main,
    },
  }
})
